import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Users, CheckCircle2, BarChart3, Layers } from "lucide-react";

export default function Org() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/org/dashboard").then(({ data }) => setData(data)); }, []);

  if (!data) return <div className="text-white/60">Loading...</div>;

  return (
    <div data-testid="org-page">
      <h1 className="font-display text-3xl md:text-4xl font-black tracking-tight">Organisation impact</h1>
      <p className="text-white/60 mt-1.5">Anonymised cohort progress. Funder-ready.</p>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-6">
        <Stat icon={Users} label="Members" value={data.members} color="#FF2A6D"/>
        <Stat icon={CheckCircle2} label="Completions" value={data.completions} color="#01FFC3"/>
        <Stat icon={BarChart3} label="Avg XP" value={data.avg_xp} color="#FFD700"/>
        <Stat icon={Layers} label="Categories engaged" value={data.categories_engaged} color="#05D9E8"/>
      </div>

      <div className="glass-card p-7 mt-6">
        <h2 className="font-display text-xl font-extrabold">Export impact report</h2>
        <p className="text-sm text-white/60 mt-1">Full anonymised cohort report (CSV/PDF) for funders. Available on request from your account manager.</p>
        <button className="btn-secondary-neon text-sm mt-4" data-testid="org-export">Request export</button>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, color }) {
  return (
    <div className="glass-card p-5">
      <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${color}22`, color }}>
        <Icon size={18}/>
      </div>
      <div className="mt-3 font-display text-3xl font-black">{value}</div>
      <div className="text-xs text-white/55 uppercase tracking-widest">{label}</div>
    </div>
  );
}
